export default (store) => (to, from, next) => {
  const originalIdParams = {
    showId: to.params.showId,
    eventId: to.params.eventId,
  };

  const { showUnderEditId, eventUnderEditId } = store.getters;

  // If from.name is empty or undefined, the navigation is not internal, i.e. from another module in Event Manager.
  const isInternalNavigation = () => from.name;

  const shouldAddEventIdParam = () => to.meta.applyEventUnderEdit && eventUnderEditId && !to.params.eventId;

  const shouldAddShowIdParam = () => to.meta.applyShowUnderEdit && showUnderEditId && !to.params.showId;

  const addShowParamIfApplicable = () => {
    if (shouldAddShowIdParam()) {
      to.params.showId = showUnderEditId;
    }
  };

  const haveParamsChanged = () => to.params.eventId !== originalIdParams.eventId || to.params.showId !== originalIdParams.showId;

  const shouldAddParams = () => isInternalNavigation() && shouldAddEventIdParam();

  const addEventAndShowParamsIfApplicable = () => {
    if (shouldAddParams()) {
      to.params.eventId = eventUnderEditId;
      addShowParamIfApplicable();

      return haveParamsChanged();
    }

    return false;
  };

  if (addEventAndShowParamsIfApplicable()) {
    to.meta.isEventUnderEditRedirect = true;
    next(to);
  } else {
    to.meta.isEventUnderEditRedirect = false;
    next();
  }
};
